import { memoize } from 'lodash'
import moment from 'moment-timezone'

export const convertUtcDateStringToLocal = memoize((dateString: string, format: string): string =>
  moment.utc(dateString).local().format(format),
)
